import { theme } from "../../theme";

export default function Notification({ message }) {
  if (!message) return null;

  return (
    <div role="alert" aria-live="polite" style={{ position: "fixed", top: 20, left: "50%", transform: "translateX(-50%)", background: theme.card, border: `1px solid ${theme.accent}`, borderRadius: 14, padding: "12px 24px", color: theme.text, fontSize: 14, fontWeight: 600, zIndex: 200, boxShadow: `0 8px 32px rgba(0,0,0,0.4)`, animation: "slideDown 0.3s ease" }}>
      {message}
    </div>
  );
}
